import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { GroupAddPage } from '../group-add/group-add';
import { GroupViewPage } from '../group-view/group-view';
import { GroupPermissionsPage } from '../group-permissions/group-permissions';
import { InvitePage } from '../invite/invite';

@Component({
  selector: 'page-groups',
  templateUrl: 'groups.html'
})
export class GroupsPage {
  // this tells the tabs component which Pages
  // should be each tab's root Page
  constructor(public navCtrl: NavController) {
  }
  goToGroupAdd(params){
    if (!params) params = {};
    this.navCtrl.push(GroupAddPage);
  }goToGroupView(params){
    if (!params) params = {};
    this.navCtrl.push(GroupViewPage);
  }goToGroupPermissions(params){
    if (!params) params = {};
    this.navCtrl.push(GroupPermissionsPage);
  }goToInvite(params){
    if (!params) params = {};
    this.navCtrl.push(InvitePage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/groups/groups.ts